// ======================================================================
// File Name       : BoxUtils
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { END_CONDITION_TYPE_FOR_BOX_LIST } from '../constants/BoxConstants';

export function isEnableBoxEndCondition(endConditionTypeForBox) {
  return END_CONDITION_TYPE_FOR_BOX_LIST.indexOf(endConditionTypeForBox) > -1;
}
